

















































import {Component, Emit, Inject, Prop, Vue} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";
import {Lading} from "@/interfaces/entity";
import {LadingStatus} from "@/enums/status";
import ComplaintCustomerForm from "@/modules/complaintcustomer/Form/index.vue";
import DetailLading from "@/modules/ladings/Detail/index.vue";
import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";

@Component({
    name: "LadingTableAction",
    components: {DetailLading, ComplaintCustomerForm}
})
export default class extends Vue {
    @Inject({ default: false }) readonly routingEdit!: boolean;
    @Prop({ required: true, type: String })
    readonly ladingId!: string;
    LadingStatus = LadingStatus;
    LadingCustomerStatus = LadingCustomerStatus;
    visibleComplaintForm = false;
    visibleDetail = false;

    get lading(): Lading {
        return LadingStore.data[this.ladingId];
    }

    set lading(value: Lading) {
        LadingStore.data[this.ladingId] = value;
    }
    async onConfirm() {
        try {
            await LadingStore.deleteLading(this.ladingId);
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa vận đơn thất bại");
        }
    }

    updateLading() {
        if(this.routingEdit) {
            this.$router.push({ name: 'updateFormLadingRouting', params: { id: this.ladingId } });
        } else {
            this.$emit("updateLading", this.ladingId);
        }
    }
}
